import { ALERTAS_CARREGANDO, ALERTAS_CARREGADO } from '../../constantes';
import { Actions, Getters, Mutations } from '../types';
import { PortalLogger as log } from '@/utils';

import AlertaServico from '../../dominio/alertas/AlertaServico';

const api = AlertaServico.build({})

// Estado inicial
const state = {
    mensagem: {},
    pendentes: [],
    recentes: [],
    status: ALERTAS_CARREGANDO
}
// getters

const getters = {
    [Getters.ALERTAS.MENSAGEM]: (st) => st.mensagem,
    [Getters.ALERTAS.PENDENTES]: (st) => st.pendentes,
    [Getters.ALERTAS.RECENTES]: (st) => st.recentes,
    [Getters.ALERTAS.STATUS_CARGA_FIM]: (st) => st.status === ALERTAS_CARREGADO
}

// actions
const actions = {

    [Actions.ALERTAS.BAIXAR]: ({ commit }, alerta) => {
        return api.baixarAlertaPortal(alerta.id, alerta.sistema)
                .then((retorno) => {
                    commit(Mutations.ALERTAS.BAIXA, retorno);
                    commit(Mutations.ALERTAS.MENSAGEM, {
                        tipo: 'success',
                        mostrar: true,
                        texto: 'Tarefa resolvida com sucesso!'
                    });
                }).catch(error => {
                    log.error(`Problema ao dar baixa no alerta ${alerta.id} do sistema ${alerta.sistema}: ${error}`);
                    commit(Mutations.ALERTAS.MENSAGEM, {
                        tipo: 'danger',
                        mostrar: true,
                        texto: 'Não foi possível resolver a tarefa, tente novamente mais tarde!'
                    });
                })
    },
    [Actions.ALERTAS.CARREGAR]: ({ commit, rootGetters }) => {
        const areas = rootGetters[Getters.AREAS.AREAS_NEGOCIO];
        commit(Mutations.ALERTAS.STATUS_CARGA_INICIO);
        return api.listarAlertasPendentes()
           .then(alertas => {
              alertas.forEach(alerta => {
                  let area = areas.find(a => a.sistema === alerta.sistema) || {};
                  alerta.setArea(area);
              });
              commit(Mutations.ALERTAS.PENDENTES, alertas);
              commit(Mutations.ALERTAS.RECENTES, alertas.slice(0,5));
           }).finally(() => {
              commit(Mutations.ALERTAS.STATUS_CARGA_FIM);
           })
    },
    [Actions.ALERTAS.VISUALIZAR]: ({ commit }, alerta) => {
        commit(Mutations.ALERTAS.ESTENDIDO, alerta)
        if(alerta.estendido){
            return api.gravarLeituraAlerta(alerta.id, alerta.sistema)
                .then((retorno) => {
                    commit(Mutations.ALERTAS.VISUALIZACAO, retorno)
                })
        }
    }
}

// mutations
const mutations = {
    [Mutations.ALERTAS.BAIXA]: (state, alerta) => {
        let indice = state.pendentes.findIndex(item => item.id == alerta.id);
        if(indice != -1){
            state.pendentes.splice(indice, 1);
        }
        if(state.recentes.find(item => item.id == alerta.id)){
            state.recentes = state.pendentes.slice(0,5)
        }
    },
    [Mutations.ALERTAS.ESTENDIDO]: (state, alerta) => alerta.estendido = !alerta.estendido,
    [Mutations.ALERTAS.LIMPAR_MENSAGEM]: (state) => state.mensagem = { mostrar: false },
    [Mutations.ALERTAS.MENSAGEM]: (state, mensagem) => state.mensagem = mensagem,
    [Mutations.ALERTAS.PENDENTES]: (state, alertas) => state.pendentes = alertas,
    [Mutations.ALERTAS.RECENTES]: (state, alertas) => state.recentes = alertas,
    [Mutations.ALERTAS.STATUS_CARGA_INICIO]: (state) => state.status = ALERTAS_CARREGANDO,
    [Mutations.ALERTAS.STATUS_CARGA_FIM]: (state) => state.status = ALERTAS_CARREGADO,
    [Mutations.ALERTAS.VISUALIZACAO]: (state, dados) => {
        let alerta = state.pendentes.find(item => item.id == dados.id);
        alerta.visualizadoEm = dados.visualizadoEm
    }
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}